import { DatesAsString, FhirLaboratoryOrderCreationParams, OrderStatus } from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';
import type { IntervalWithOrganizationQuery } from 'chaika-types';

const BASE_URL = '/api/fhir/order';

interface RegystryQuery extends Omit<DatesAsString<IntervalWithOrganizationQuery>, 'organizationIds'> {
    organizationId: string;
}

export class FhirLaboratoryOrderApi {
    public static async create(order: FhirLaboratoryOrderCreationParams): Promise<void> {
        await axios.post(BASE_URL, { order });
    }

    public static async cancel(orderId: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${orderId}`);
    }

    public static async forceCancel(orderId: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${orderId}/force`);
    }

    public static async updateStatus(
        orderId: string,
        status: OrderStatus,
        additionalServiceIds?: string[],
    ): Promise<void> {
        await axios.put(`${BASE_URL}/${orderId}/status`, { status, additionalServiceIds });
    }

    public static async updateEntryResults(orderId: string): Promise<void> {
        await axios.post(`${BASE_URL}/${orderId}/update-results`);
    }

    public static async downloadRegistry({ organizationId, ...params }: RegystryQuery): Promise<void> {
        window.open(
            `/api/laboratory-report/registry?from=${params.from}&to=${params.to}&organizationIds=${organizationId}`,
            '_blank',
        );
    }

    public static async sendRegistry({ organizationId, ...params }: RegystryQuery): Promise<void> {
        await axios.post(`/api/laboratory-report/registry`, {
            ...params,
            organizationIds: organizationId,
        });
    }
}
